import _ from 'lodash'

const getCategory = (withSubCategories, categoriesInObj) => {
  let headCategory = ''
  if (!_.isEmpty(categoriesInObj)) {
    if (
      _.some(categoriesInObj, ['description', 'university']) ||
      _.some(categoriesInObj, ['description', 'university-levels'])
    ) {
      headCategory = _.head(
        _.filter(categoriesInObj, (cat) => cat.description === 'university')
      )
    } else {
      headCategory = _.head(
        categoriesInObj.filter(({ description: id1 }) =>
          withSubCategories.some(({ description: id2 }) => id2 === id1)
        )
      )
    }
  }
  return _.head(
    _.filter(
      withSubCategories,
      (cat) => cat.description === _.get(headCategory, 'description', null)
    )
  )
}

export default getCategory
